import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Trans } from '@lingui/macro';
// @ts-ignore
import { ThemeContext } from '@qover/styles';
import { LinkMixin } from '@qover/typography';
import { EmailModal } from '../modals';
import { useSubmitAndCloseOnTimeout } from '@qover/hooks';

const pushEmail = (label: string) => {
  // @ts-ignore
  dataLayer.push({
    event: 'saveMyOffer',
    eventCategory: 'save my offer',
    eventAction: 'click to open',
    eventLabel: label,
  });
};

const pushEmailOpen = () => pushEmail('open');
const pushEmailSubmit = () => pushEmail('send email');
const pushEmailClose = () => pushEmail('close');

const EditButton = styled.span`
  ${LinkMixin};
  align-items: center;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary()};
  display: flex;
  justify-content: center;

  & > svg {
    fill: currentColor;
    margin-right: 10px;
    width: 17px;
    height: 12px;
  }

  &.text-left {
    justify-content: flex-start;
  }
`;

const MailIcon = () => (
  <svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="nonzero"
      d="M1.97 0L1.8.007A1.974 1.974 0 00.007 1.803L0 1.962v8.068l.007.168c.078.955.85 1.718 1.795 1.795l.16.007h13.24l.17-.007a1.974 1.974 0 001.794-1.796l.006-.159V1.97l-.006-.168A1.974 1.974 0 0015.37.007L15.21 0H1.97zm7.896 7.871l.925-.834 3.572 3.462H2.809l3.585-3.457.917.823.147.12c.676.498 1.614.49 2.279-.008l.129-.106zM1.514 9.654V2.66l3.753 3.368-3.753 3.626zM15.659 2.66v6.99L11.916 6.02l3.743-3.361zM2.477 1.5h12.225L8.839 6.762l-.068.053c-.132.085-.254.072-.375-.013l-.06-.048L2.476 1.5z"
    />
  </svg>
);

type EmailModalTriggerProps = React.PropsWithChildren<{
  'data-test'?: string;
  className?: string;
  onSubmit: ((form: any) => Promise<unknown>) | undefined;
  showIcon?: boolean;
  email?: string;
  disabled?: boolean;
}>;

export const EmailModalTrigger: React.FC<EmailModalTriggerProps> = props => {
  const theme = useContext<any>(ThemeContext);

  const { showIcon = true } = props;

  const onSubmit = (form: any) => {
    pushEmailSubmit();
    // @ts-expect-error
    return props.onSubmit(form);
  };
  const { isOpen, setIsOpen, submitAndClose } = useSubmitAndCloseOnTimeout(
    onSubmit,
  );

  useEffect(() => {
    if (isOpen) {
      pushEmailOpen();
    }
  }, [isOpen]);

  if (!theme?.featureToggles?.showSendMyOffer) {
    return null;
  }

  return (
    <>
      <EditButton
        className={cx('bold', props.className)}
        data-test={props['data-test']}
        onClick={() => setIsOpen(true)}
      >
        {showIcon && <MailIcon />}
        {props.children || <Trans id="general.emailPopup.saveOffer" />}
      </EditButton>
      {isOpen && (
        <EmailModal
          email={props.email}
          onSubmit={submitAndClose}
          onClose={() => {
            pushEmailClose();
            setIsOpen(false);
          }}
          disabled={props.disabled}
        />
      )}
    </>
  );
};
